/*
 * The wrapping ol and list li is baked into
 * Algolia widget. Adjust the classes on those in
 * ElementsSearchResults.js
 * See: https://www.algolia.com/doc/api-reference/widgets/infinite-hits/js/#widget-param-cssclasses
 */
export const generatorHitTpl = `

<div class="">
    <div class="relative group">
        <figure class="relative flex items-center w-full h-48 overflow-hidden transition bg-white group-hover:opacity-50 ">
            <picture class="w-full h-full">
             {{# Algolia Image }}
              <img src="{{ Algolia Image }}?w=250&h=250&fit=fill&trim=color&pad=40&bg=FFFFFF&fill=solid&fill-color=FFFFFF&auto=format" alt="{{ title }}" class="object-contain h-full w-full" />
            {{/ Algolia Image }}
            {{^Product Image}}
             <img src="https://hamiltonpower.imgix.net/images/engine-fpo.png?w=600&h=600&fit=fill&trim=color&pad=40&bg=FFFFFF&fill=solid&fill-color=FFFFFF&auto=format" alt="{{ title }}" class="object-contain h-full w-full" />
            {{/Product Image}}
            </picture>
            <div class="absolute inset-x-0 inset-y-0 top-0 left-0 block bg-gray-900 opacity-5"></div>
        </figure>
        <h3 class="mt-4 text-base text-gray-700">
            <a href="{{ url }}">
                <span class="absolute inset-0"></span>
                <strong class="text-gray-900">{{#Brands}}{{ . }}{{/Brands}} {{ modelVariant }}</strong>

               <table class="text-xs mt-2 mb-4 w-full leading-tight">
                    <tr>
                        <td class="font-bold">Power Rating</td>
                        <td class="pl-1 pb-2">
                          {{#Power Rating HP}}{{ Power Rating HP }} HP <br>{{/Power Rating HP}}
<!--                          {{#Power Rating Kva}}{{ Power Rating Kva }} Kva <br>{{/Power Rating Kva}}-->
                          {{#Power Rating KW}}{{ Power Rating KW }} kW <br>{{/Power Rating KW}}
                      </td>
                    </tr>
                    <tr>
                        <td class="font-bold">Liters</td>
                        <td class="pl-1 pb-2">{{Displacement Liters}}</td>
                    </tr>
                    <tr>
                      <td class="font-bold">Emissions</td>
                      <td class="pl-1">
                      {{#US Emissions}}US {{.}}<br>{{/US Emissions}}
                      {{#EU Emissions}}EU {{.}}<br> {{/EU Emissions}}
                      </td>
                    </tr>

                </table>

                <span class="block">{{ summary }}</span>
            </a>
        </h3>
    </div>




    <div class="flex mt-1">
    {{moreThanOne}}
        <a href="/contact" class="flex-1 flex-grow-0 inline-block px-2 py-1 mr-1 text-xs font-medium text-center text-navy-800 transition bg-navy-800/10 hover:bg-navy-800 hover:text-white">Request&nbsp;Pricing</a>

        {{#moreThanOneDownload}}
            <a href="{{url}}#downloads"
                class="flex-none inline-block px-2 py-1 mr-1 text-xs font-medium text-center text-navy-800 transition bg-navy-800/10 hover:bg-navy-800 hover:text-white">
                PDFs
            </a>
        {{/moreThanOneDownload}}
        {{^moreThanOneDownload}}
            {{#Product Downloads}}
            <a href="{{Product Downloads}}"
                class="flex-none inline-block px-2 py-1 mr-1 text-xs font-medium text-center text-navy-800 transition bg-navy-800/10 hover:bg-navy-800 hover:text-white"
                target="_blank">
                PDF
            </a>
            {{/Product Downloads}}
        {{/moreThanOneDownload}}



    </div>

</div>


<!--  <a-->
<!--    href="{{ cardUrl }}"-->
<!--    data-modal="{{ multipleSpecSheets }}"-->
<!--    data-module="GeneratorCard"-->
<!--    class="flex flex-row h-full overflow-hidden transition transform bg-white md:flex-col group">-->
<!--    <figure class="flex-shrink-0 w-24 pr-2 md:w-full md:pb-0 mdd:pt-4 sm:pr-4 md:pr-0">-->
<!--      <img src="{{ image }}" alt="Image of {{ title }}" class="mx-auto max-w-full" />-->
<!--    </figure>-->
<!--    <div class="h-full pt-4 pb-8 pr-4 md:px-4 lg:px-6 smd:pb-6">-->
<!--        <h3 class="text-xl leading-normal text-gray-900 font-bold mdd:group-hover:underline">-->
<!--          {{ title }}-->
<!--        </h3>-->
<!--        <p class="mt-px text-base leading-normal text-gray-700 smd:leading-snug">-->
<!--          {{ Power Rating }}-->
<!--            Powered by {{ Engine Manufacturer }}-->
<!--        </p>-->

<!--        {{#multipleSpecSheets }}-->
<!--          <button class="text-sm font-bold text-red-500 group-hover:bg-gray-200 transition">-->
<!--          View Downloads-->
<!--          </button>-->
<!--        {{/multipleSpecSheets }}-->
<!--        {{^multipleSpecSheets }}-->
<!--          <button class="text-sm font-bold text-red-500 group-hover:bg-gray-200 transition">-->
<!--            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-down-to-line" class="align-baseline mr-1 h-3 inline-block" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M297.4 169.4L224 242.8V64c0-17.69-14.31-32-32-32S160 46.31 160 64v178.8L86.63 169.4C80.38 163.1 72.19 160 64 160S47.63 163.1 41.38 169.4c-12.5 12.5-12.5 32.75 0 45.25l128 128c12.5 12.5 32.75 12.5 45.25 0l128-128c12.5-12.5 12.5-32.75 0-45.25S309.9 156.9 297.4 169.4zM352 416H32c-17.69 0-32 14.31-32 32s14.31 32 32 32h320c17.69 0 32-14.31 32-32S369.7 416 352 416z"></path></svg>-->
<!--          Specifications-->

<!--          </button>-->
<!--        {{/multipleSpecSheets }}-->
<!--    </div>-->
<!--  </a>-->
`;
